import L from "leaflet";

window.L = L;
export default L;
